// Country options
export const countries = [
  { value: 'United States', label: 'United States' },
  { value: 'Canada', label: 'Canada' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'Germany', label: 'Germany' },
  { value: 'France', label: 'France' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Finland', label: 'Finland' },
  { value: 'Australia', label: 'Australia' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Japan', label: 'Japan' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Hong Kong', label: 'Hong Kong' },
  { value: 'India', label: 'India' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Chile', label: 'Chile' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'Other', label: 'Other' },
];

// How found us options
export const howFoundUsOptions = [
  { value: 'Invited by Jua team', label: 'Invited by Jua team' },
  { value: 'Direct (typed URL)', label: 'Direct (typed URL)' },
  { value: 'Google Search', label: 'Google Search' },
  { value: 'LinkedIn', label: 'LinkedIn' },
  { value: 'Twitter/X', label: 'Twitter/X' },
  { value: 'Facebook', label: 'Facebook' },
  { value: 'Reddit', label: 'Reddit' },
  { value: 'Word of mouth', label: 'Word of mouth' },
  { value: 'Conference/Event', label: 'Conference/Event' },
  { value: 'Blog/Article', label: 'Blog/Article' },
  { value: 'Other', label: 'Other' },
];

// Role description options
export const roleOptions = [
  { value: 'Trader', label: 'Trader' },
  { value: 'Meteorologist', label: 'Meteorologist' },
  { value: 'Analyst', label: 'Analyst' },
  { value: 'Developer', label: 'Developer' },
  { value: 'Executive', label: 'Executive' },
  { value: 'Investor', label: 'Investor' },
  { value: 'Other', label: 'Other' },
];

// User type options
export const userTypeOptions = [
  { value: 'private', label: 'Private' },
  { value: 'business', label: 'Business' },
];
